import { Button } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { QUERY_KEYS } from "constant/react_query";
import { useAuthLogin } from "hooks/auth/useAuthLogin";
import InputField from "components/UI/InputField/InputField";
import { useAuthAdmNavigate } from "./useAuthAdmNavigate";

const LoginForm = () => {
  useAuthAdmNavigate();
  const { handleSubmit, control } = useForm({});

  const { loginMutate } = useAuthLogin({
    invalidateKeys: [QUERY_KEYS.AUTH_CURRENT_GET],
  });

  const onSubmit = async (data: any) => {
    loginMutate(data, {
      onSettled(data, error) {
        if (data) {
          // toast.success("Login succeed");
        } else {
          if (error) {
            console.error("Login error", error);
          }
          toast.error("Login failure");
        }
      },
    });
  };

  return (
    <Form>
      <InputField
        name="un"
        control={control}
        label="Korisničko ime"
        defaultValue={""}
      />
      <InputField
        name="pw"
        control={control}
        label="Lozinka"
        defaultValue={""}
        type="password"
      />
      <Button type="submit" onClick={handleSubmit(onSubmit)}>
        OK
      </Button>
    </Form>
  );
};

const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: 3rem;

  &&& div {
    margin-bottom: 1rem;
  }
`;

export default LoginForm;
